import { render, staticRenderFns } from "./VerificationHeader.vue?vue&type=template&id=e5914b38&scoped=true&"
import script from "./VerificationHeader.vue?vue&type=script&lang=js&"
export * from "./VerificationHeader.vue?vue&type=script&lang=js&"
import style0 from "./VerificationHeader.vue?vue&type=style&index=0&id=e5914b38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5914b38",
  null
  
)

export default component.exports